import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the revision plan id.
 */
export default function RevisionPlanIdColumn({ data: { revisionPlanId } }: { data: RevisionPlanRow }) {
  return <P3Regular color="gray.8">{revisionPlanId}</P3Regular>;
}
